export default {"src":"/login-app/[GIT_HASH]/_next/static/media/slack.90c56bb0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};